import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
    // Debug logging to ensure environment is loaded correctly
    console.log('ApiService initialized with apiUrl:', this.apiUrl);
    console.log('Environment object:', environment);
    
    if (!this.apiUrl) {
      console.error('CRITICAL: API URL is not configured! Environment:', environment);
    }
  }

  getApiUrl(): string {
    if (!this.apiUrl) {
      console.error('getApiUrl() called but apiUrl is empty! Environment:', environment);
    }
    return this.apiUrl;
  }

  get<T>(path: string): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}${path}`);
  }

  post<T>(path: string, body: any = {}): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}${path}`, body);
  }

  patch<T>(path: string, body: any = {}): Observable<T> {
    return this.http.patch<T>(`${this.apiUrl}${path}`, body);
  }

  delete<T>(path: string): Observable<T> {
    return this.http.delete<T>(`${this.apiUrl}${path}`);
  }

  upload<T>(path: string, formData: FormData): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}${path}`, formData);
  }

  getBlob(path: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}${path}`, {
      responseType: 'blob',
    });
  }
}
